import { Autocomplete, Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { useEffect, useState } from "react";
import { fetchInvoicesData, getAssigneeList, multiInvoiceReassign } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { invoiceActions } from "src/context/invoice-slice";
import { useDispatch } from "react-redux";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useNavigate } from "react-router-dom";

const InvoiceMultiReAssign = ({ onCloseModal, invoiceData, onSuccess, fuidStatusId }: { onCloseModal: () => void; invoiceData: any; onSuccess: () => void; fuidStatusId?: number }) => {
  const [assigneeList, setAssigneeList] = useState<any>([]);
  const [reassigneeId, setReassigneeId] = useState<number>();
  const { selectedInvoices, InvoiceFilters } = useSelector((state: RootState) => state.invoice);
  const [isAssigning, setIsAssigning] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const company_code = InvoiceFilters?.company?.[0]?.code;

  const { withEventCheck } = useEventStatus();

  const { toast } = useToast();

  const fetchAssigneeList = async () => {
    try {
      const res = await getAssigneeList(company_code);
      setAssigneeList(res?.data?.data?.filter((item: any) => item?.invoice_assignment_id !== invoiceData?.InvoiceAssignment?.invoice_assignment_id));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAssigneeList();
  }, []);

  const handleReassign = async () => {
    setIsAssigning(true);
    const selectedStockistAttachment = selectedInvoices
      .filter((invoice: any) => invoice?.invoice_assignment_id !== reassigneeId)
      .map((invoice: any) => invoice.key);
    const payload = {
      stockist_invoice_attachment_id: selectedStockistAttachment,
      reassign_to: reassigneeId,
      company_code:company_code
    };
    try {
      if (!reassigneeId) {
        toast({ description: "Please select a assignee", variant: "destructive" });
        return;
      }
      if (selectedInvoices?.length == 0) {
        toast({ description: "Please select a invoice to re-assign", variant: "destructive" });
        return;
      }
      const res = await multiInvoiceReassign(payload, company_code);
      console.log(res);
      const invoiceStatusUpdateResponse = await withEventCheck(
        async () => {
          const params = {
            fuid_status_id: fuidStatusId || 1,
            page_number: 1,
            page_size: 10,
          };
          const allInvoicesRes = await fetchInvoicesData(params);
          if (fuidStatusId === 1) {
            dispatch(invoiceActions.setInvoiceData(allInvoicesRes?.data?.data?.invoiceData || []));
          } else {
            dispatch(invoiceActions.setInvoiceApprovalList(allInvoicesRes?.data?.data?.invoiceData || []));
          }
          navigate("/transactions/invoice/0")
        },
        res?.data?.data?.eventStreamCreated?.streamId
      );
      console.log(invoiceStatusUpdateResponse)
      if (res?.data?.success === true) {
        toast({ description: res?.data?.data || "Invoice reassigned successfully", variant: "default" });
        onCloseModal();
      } else {
        toast({ description: res?.data?.message || "Invoice reassigned failed", variant: "destructive" });
        onCloseModal();
      }
      onSuccess();
      console.log(payload);
      setIsAssigning(true);
      dispatch(invoiceActions.clearSelectedInvoices());
    } catch (error: any) {
      console.log(error);
      setIsAssigning(true);
    } finally {
      onCloseModal();
      setIsAssigning(true);
    }
  };

  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Re-assign Multiple Invoices</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm mb-2 font-normal text-[#666666]">Select a assignee</p>
      <Autocomplete
        inputClassName="w-full"
        placeholder="Select a assignee"
        suggestionList={assigneeList}
        displayKey="user_name"
        uniqueKey="invoice_assignment_id"
        onSelectionChange={(e: any) => setReassigneeId(e?.invoice_assignment_id)}
      />
      <div className="mt-4">
        <p className="text-sm mb-0 font-normal text-[#666666]">Selected Invoices: {selectedInvoices?.length}</p>
        <p className="mt-2 text-sm mb-0 font-normal text-[#666666]">{selectedInvoices?.map((invoice: any) => invoice?.fuid_no)?.join(", ")}</p>
      </div>
      <Button disabled={isAssigning} loaderSize="small" isLoading={isAssigning} className="text-white bg-[#8051FF] mt-4" onClick={handleReassign}>
        Proceed
      </Button>
    </div>
  );
};

export default InvoiceMultiReAssign;
